import { useControl } from "@essenza/react";
import { Avatar, Button, Col, List, Row, Tag } from "antd";
import { UserOutlined } from '@ant-design/icons';
import { JobService } from "../service/JobService";

function CandidateListController(c) {
    c.skin = CandidateList;
    c.command = {
        CONTACT: (user, { data }) => {
            if (data)
                c.request(JobService, s => s.contact(data, user));
            c.navigate("/contatto", { candidate: user, job: data });
        },
        SEEN: (user, { data }) => {
            if (data)
                c.request(JobService, s => s.seen(data, user));
        },
        DISCARD: (info, { data }) => {
            c.request(JobService, s => s.discard(data, info.u)).then(() => info.n.refresh());
        },
        RECOVER: (info, { data }) => {
            c.request(JobService, s => s.recover(data, info.u)).then(() => info.n.refresh());
        }
    }
}

export function CandidateList({ source, column, job }) {
    const [control] = useControl(CandidateListController);
    if (!source.data) return null;
    const t = '?' + new Date().getTime();
    return (
        <>
            <div>
                <List dataSource={source.getCollection()}
                    grid={column ? {
                        gutter: 16,
                        xs: 1,
                        sm: 1,
                        md: 2,
                        lg: 2,
                        xl: 3,
                        xxl: 3,
                    } : null}
                    renderItem={user => (
                        <List.Item>
                            <div className="w100 padding-md bg-pri round-sm" style={{ textAlign: 'left' }}>
                                <Row gutter={24} wrap={column}>
                                    <Col flex="64px">
                                        {user.img ? <img src={user.img + t} width="64" height="64" alt="Immagine Profilo" /> : <Avatar size={64} icon={<UserOutlined />} />}
                                    </Col>
                                    <Col flex="220px" className="ml-md">
                                        <h2>{user.tname + ' ' + user.tsurname}</h2>
                                        <Row className="pt-sm">
                                            <Col>
                                                {user.cvdate && <Button target="_blank" href={'/cv/' + user.tsurname + '_' + user.tname + '_CV' + user.id + '.pdf'} style={{ padding: '0' }} type="link">Curriculum</Button>}
                                            </Col>
                                            <Col className="pl-md">
                                                {user.tportfolio && <Button target="_blank" href={user.tportfolio} type="link">Portfolio</Button>}
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col>
                                                <p><span style={{ fontWeight: "700" }}>Vive a</span> {user.tsite}</p>
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col flex="auto">
                                        <h5 className="pb-sm">Skills</h5>
                                        {user.skills ? user.skills.map(s => s.name === ' ' ? null : <Tag className="mb-xs">{s.name}</Tag>) : null}
                                    </Col>
                                </Row>
                                {user.tmessage && <h6>Messaggio inviato il {new Date(user.tmessage).toLocaleString("it-IT")}</h6>}
                                <Row>
                                    <Col flex="none" className="mt-sm">
                                        {user.discard
                                            ? <Button className="primaryButton" onClick={() => control.execute("RECOVER", { u: user, n: source.node }, job)}>Rivaluta</Button>
                                            : <Button className="primaryButton" onClick={() => control.execute("CONTACT", user, job)}>Contatta</Button>}
                                    </Col>
                                    <Col flex="auto" className="mt-sm">
                                        {!user.discard && job && job.istatus !== 2 && <Button className="secondaryButton ml-sm" onClick={() => control.execute("DISCARD", { u: user, n: source.node }, job)}>Scarta</Button>}
                                    </Col>
                                </Row>
                            </div>
                        </List.Item>
                    )}
                />
            </div>
        </>
    )
}